import { PolicyPageLayout } from '@/components/ui/PolicyPageLayout';
import { useTermsText } from '@/hooks/useTermsText';

export function TermsOfService() {
  const { termsText } = useTermsText();

  return <PolicyPageLayout title="Terms of Service" blocks={termsText} />;
}
